// @flow
import React from 'react'
import styled, { css } from 'styled-components'
import { fontSize, spacing } from 'frontend_core/dist/styles/variables'

import Colors from 'components/styles/colors'
import ReservationDate from 'components/molecules/ReservationDate'
import MediaSpace from 'components/molecules/MediaSpace'
import BillStatement, {
  type PropTypes as BillStatementProps,
} from 'components/molecules/BillStatement'

export type PropTypes = {
  dateText: string,
  prevDateText?: ?string,
  srcSpaceImage?: ?string,
  textSpaceName: string,
  billStatementProps: BillStatementProps,
}

const ReserveChangeRequestWrap = styled.div`
  margin-top: ${spacing.large}px;
`
const ReserveChangeRequestContent = styled.div`
  margin-top: ${spacing.medium}px;
`
const BlockReserveChangeRequest = styled.div`
  padding: ${spacing.medium_2}px 0;
  border-top: 1px solid ${Colors.grayE};

  &:last-of-type {
    border-bottom: 1px solid ${Colors.grayE};
  }
`

export default function ReservationChangeRequestBlock(props: PropTypes) {
  return (
    <ReserveChangeRequestWrap>
      <ReservationDate
        dateText={props.dateText}
        prevDateText={props.prevDateText}
      />
      <ReserveChangeRequestContent>
        <BlockReserveChangeRequest>
          <MediaSpace src={props.srcSpaceImage} text={props.textSpaceName} />
        </BlockReserveChangeRequest>
        <BlockReserveChangeRequest>
          <BillStatement {...props.billStatementProps} />
        </BlockReserveChangeRequest>
      </ReserveChangeRequestContent>
    </ReserveChangeRequestWrap>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/ReservationChangeRequestBlock/index.jsx